import React, { lazy, Suspense } from 'react';

const LazyPreRegistrationDetail = lazy(
  () => import('./DriverManagementDetail')
);

const DriverManagementDetail = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode }
) => (
  <Suspense fallback={null}>
    <LazyPreRegistrationDetail {...props} />
  </Suspense>
);

export default DriverManagementDetail;
